import gsap from 'gsap'
import { bp, callAfterResize, mm, preventOrphan, sel, selAll, stResizeObserver, wrapLastTwo } from './utils'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player'
import './video.css'

gsap.registerPlugin(SplitText, ScrollTrigger)

export default function Exec() {
  const isSafariMac = !!(window.safari && window.safari.pushNotification)
  const chromeBlur = !isSafariMac ? { filter: 'blur(50px)' } : {}
  window.addEventListener('load', function () {
    document.fonts.load('1rem "DM Sans"').then(() => {
      console.log('Epic.js loaded 27', isSafariMac)
      // return
      const navbarW$ = sel('.navbar-a')
      const navbar$ = sel('#navbar')
      const hero$ = sel('.hero')
      gsap.set(hero$, { zIndex: 30 })
      // const compInfo$ = header$.querySelector('.hero__info--epic')
      const heroP$ = hero$.querySelector('.hero__p--epic')
      const heroBtn1$ = hero$.querySelectorAll('.btn')[0]
      const heroBtn2$ = hero$.querySelectorAll('.btn')[1]

      const heroBg$ = hero$.querySelector('.hero__bg-w--vid')
      // const heroBg$ = hero$.querySelector('.hero__epic-svg')
      const heroTag$ = hero$.querySelector('.hero__tag--epic')
      // const compHsT = new SplitType('.comp-hero__h', { types: 'words, chars' })
      const compHsT = SplitText.create('.h1--epic', { type: 'chars, words' }) // words to keep the initial wrapping
      const epicSvgW$ = sel('.epic--hero--img')

      async function headerVid() {
        // for vimeo player
        const _player = hero$.querySelector('.custom_player.is--epic')
        let src = _player.getAttribute('data-src')
        // Ensure Vimeo loop/background params appended (Vidstack passes through to provider)
        if (src && src.startsWith('vimeo/')) {
          // Avoid duplicating params
          if (!/[?&](loop|background)=/.test(src)) {
            src += (src.includes('?') ? '&' : '?') + 'loop=1&background=1&autopause=0&muted=1'
          }
        }
        const headerPlayer = await VidstackPlayer.create({
          target: _player,
          src: src,
          crossOrigin: true,
          playsInline: true,
          viewType: 'video',
          // Load eagerly so first frame is available ASAP for background.
          load: 'eager',
          // Remove layout to hide all default UI/controls for background usage
          // layout: new VidstackPlayerLayout(),
          // Attempt autoplay background settings (Vidstack will handle attribute mapping)
          autoplay: true,
          muted: true,
          loop: true,
          // preload: 'auto', // (If supported by vidstack version)
        })
        // Ensure background playback (muted required for most browsers)
        headerPlayer.muted = true
        headerPlayer.loop = true
        // Make sure parent hero allows absolute positioning.
        // if (getComputedStyle(hero$).position === 'static') {
        //   hero$.style.position = 'relative'
        // }
        // Mark ready (fade-in) once playable
        // const markReady = () => _player.classList.add('is-ready')
        // Some browsers block autoplay until can-play; ensure play attempt
        const markReady = () => _player.classList.add('is-ready')
        const attemptPlay = () => {
          const p = headerPlayer.play()
          if (p && typeof p.then === 'function') {
            p.then(() => markReady()).catch(() => {
              // Retry once muted (already muted) after slight delay.
              setTimeout(() => {
                headerPlayer
                  .play()
                  .then(markReady)
                  .catch(() => {
                    // Final fallback: still show first frame if available.
                    markReady()
                  })
              }, 150)
            })
          } else {
            markReady()
          }
        }
        const onCanPlay = () => attemptPlay()
        if (headerPlayer.state?.canPlay) onCanPlay()
        else headerPlayer.addEventListener('can-play', onCanPlay, { once: true })
        // In case can-play never fires (provider quirk), time out fallback.
        setTimeout(() => {
          if (!_player.classList.contains('is-ready')) attemptPlay()
        }, 4000)

        // Safari sometimes ignores loop on provider-backed media; add manual fallback.
        const ua = navigator.userAgent
        const isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua)
        if (isSafari) {
          const manualLoop = () => {
            try {
              // Reset to start and play again.
              headerPlayer.currentTime = 0
              const p2 = headerPlayer.play()
              if (p2 && p2.catch) p2.catch(() => {})
            } catch (e) {}
          }
          headerPlayer.addEventListener('ended', manualLoop)
          // Pre-empt: if near end and stalls, force loop.
          headerPlayer.addEventListener('time-update', () => {
            const dur = headerPlayer.duration || 0
            if (dur && headerPlayer.currentTime >= dur - 0.05) manualLoop()
          })
        }
      }
      headerVid()

      mm.add(bp.tabUp, () => {
        gsap
          .timeline({ defaults: { ease: 'power4.out', duration: 2 } })
          .from(
            compHsT.chars,
            {
              autoAlpha: 0,
              // filter: 'blur(50px)',
              ...chromeBlur,
              stagger: {
                amount: 1.25,
              },
              duration: 0.5,
              ease: 'none',
            },
            0.5
          )
          .from(heroP$, { autoAlpha: 0, y: -20, duration: 2 }, '>-0.5')
          .from(heroBtn1$, { autoAlpha: 0, y: -20 }, '<0.25')
          .from(heroBtn2$, { autoAlpha: 0, y: -20 }, '<0.1')
          .from(heroBg$, { autoAlpha: 0, duration: 10, ease: 'none' }, '<+0.15')
          .from(heroTag$, { autoAlpha: 0 }, '<+0.15')

        const intro$ = sel('.epic-intro-sec')
        const introBg$ = sel('.epic-intro__bg-w')
        const introDim$ = sel('.epic-intro__dim-top')
        const introBlend$ = sel('.epic-intro__dim')
        const introVidBg$ = sel('.epic-intro__vid-bg-w')
        const introH$ = intro$.querySelector('h2')
        const introHsT = SplitText.create(introH$, { type: 'chars, words' })
        gsap.set(hero$, { marginBottom: '-100vh' })
        gsap.set(introBlend$, { display: 'none' })
        // gsap.set(introVidBg$, { scale: 1.2 })
        const introTl = gsap
          .timeline({ defaults: { ease: 'none', duration: 2 } })
          // .from(introVidBg$, { autoAlpha: 0, ...(!isSafariMac ? { scale: 1.2 } : {}), duration: 7 }, 0)
          .from(introDim$, { autoAlpha: 1, duration: 7 }, 0)
          .from(introVidBg$, { scale: 1.2, duration: 7 }, 0)
          .from(
            introHsT.chars,
            {
              autoAlpha: 0,
              // filter: 'blur(50px)',
              ...chromeBlur,
              stagger: {
                each: 0.04,
              },
              duration: 1.5,
            },
            0.5
          )
          .from(intro$, { marginBottom: '-100vh' }, 5)
        ScrollTrigger.create({
          trigger: hero$,
          start: 'top top+=1',
          end: '300%',
          scrub: true,
          pin: intro$,
          animation: introTl,
        })
      })
      console.log('i')
      // Props sec
      const prop$a = selAll('.epic-props__item')
      prop$a.forEach((prop$) => {
        // console.log(prop$)
        const p$a = prop$.querySelectorAll('.p--epic')
        p$a.forEach((p$) => {
          // gsap.set(p$, { marginBottom: '1.5rem' })
        })
        const pW$ = prop$.querySelector('.p-w--epic')
        selAll('.p--epic').forEach((p$) => {
          wrapLastTwo(p$)
          console.log('p$', p$)
        })
        const pWSt = SplitText.create(pW$, { type: 'words' })

        const propTl = gsap.timeline({ defaults: { duration: 1, ease: 'none' } }).from(pWSt.words, {
          autoAlpha: 0.2,
          stagger: { amount: 5 },
        })
        ScrollTrigger.create({
          trigger: prop$,
          start: 'top bottom',
          // end: (p$a.length - 1) * 200 + '%',
          end: 'bottom 75%',
          scrub: true,
          animation: propTl,
          // markers: true,
        })
      })
      // Test

      const epic$ = sel('.epic-props-sec')
      const testW$ = sel('.epic-test-sec-w')
      const test$ = sel('.epic-test-sec')
      const testC$ = sel('.epic-test__c')
      const testA$ = test$.querySelector('.btn')
      const tableW$ = sel('.epic-table-sec-w')
      const table$ = sel('.epic-table-sec')
      gsap.set(test$, { marginTop: '-100vh' })
      // gsap.set(test$, { marginTop: '-100vh', marginBottom: '-100vh' })

      const testTl = gsap.timeline({ defaults: { ease: 'none', duration: 1 } })
      ScrollTrigger.create({
        trigger: epic$,
        start: 'bottom bottom',
        end: '+=100%',
        // end: '+=200%',
        scrub: true,
        pin: test$,
        // pinSpacing: false,
        // animation: testTl,
      })
      async function videoModal() {
        const videoBtn$ = sel('#customPlayerBtn')
        if (!videoBtn$) return

        const sec$ = sel('.epic-test-sec')
        const modW$ = sel('body').appendChild(sec$.querySelector('.mod-w'))

        const close$ = modW$.querySelector('.mod__x-w')
        const mod$ = modW$.querySelector('.mod')
        const bg$ = modW$.querySelector('.mod-bg')
        modW$.classList.add('display-hide')

        const _player = modW$.querySelector('.custom_player.is--test')
        // console.log(_player.getAttribute('src'))
        const src = _player.getAttribute('data-src') || 'youtube/4UgnVc7kRxE'
        const player = await VidstackPlayer.create({
          target: _player,
          src: src,
          // src: 'vimeo/1061484821',
          poster:
            'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/6826898440714274aa9fd120_67575b133690ca3c5bb9254a_test_img1_q85-gigapixel-low%20resolution%20v2-4x%20copy.webp',
          crossOrigin: true,
          playsInline: true,
          viewType: 'video',
          load: 'idle',
          layout: new VidstackPlayerLayout(),
        })

        const tl = gsap
          .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
          .to(
            {},
            {
              onStart: () => {
                modW$.classList.remove('display-hide')
              },
              onReverseComplete: () => {
                modW$.classList.add('display-hide')
              },
              duration: 0.1,
            }
          )
          .to(modW$, { opacity: 1 })
          .from(mod$, { y: 50 }, 0)

        const closeModal = (e) => {
          e?.stopImmediatePropagation()
          tl.reverse()
          player.pause()
        }

        videoBtn$.onclick = (e) => {
          // console.log('pl', player.state.canPlay)
          tl.play()

          if (player.state.canPlay) {
            player.play()
          } else {
            player.addEventListener(
              'can-play',
              (event) => {
                // console.log('canplay')
                player.play()
              },
              { once: true }
            )
          }
        }
        ;[close$, bg$].forEach((el) => {
          el.onclick = closeModal
        })

        player.addEventListener('ended', (event) => {
          closeModal()
        })

        callAfterResize(() => closeModal())
        // console.log('videoBtn$', videoBtn$)
      }
      videoModal()

      mm.add(bp.landDown, () => {
        // Table
        const tableTab$a = selAll('.epic-table__col.is--header')
        tableTab$a.forEach((tab$) => {
          const tabColClass = tab$.dataset.col
          // console.log('tabColClass', tabColClass)

          tab$.addEventListener('click', function () {
            // console.log('tabColClass', tabColClass)
            tableTab$a.forEach((tab$) => {
              if (this === tab$) return
              tab$.classList.remove('is--active')
              this.classList.add('is--active')

              const dataClass = this.dataset.col
              const dataItem$a = selAll('.epic-table__col.is--data')
              dataItem$a.forEach((item$) => {
                if (item$.classList.contains(dataClass)) {
                  item$.style.display = 'flex'
                } else {
                  item$.style.display = 'none'
                }
              })
            })
          })
        })
      })
      mm.add(bp.tabUp, () => {
        const tableTable$ = sel('.epic-table')
        const tableCol1Cell$a = selAll('.epic-table__col.is--1')
        const tableCol2Cell$a = selAll('.epic-table__col.is--2')
        const tableCol3Cell$a = selAll('.epic-table__col.is--3')
        const tableCol4Cell$a = selAll('.epic-table__col.is--4')
        const rowTw = {
          x: 10,
          autoAlpha: 0,
          stagger: 0.1,
          ease: 'power1.out',
        }
        const tableTl = gsap
          .timeline({ defaults: { ease: 'none', duration: 1 } })
          .from(tableCol1Cell$a, rowTw, 0)
          .from(tableCol2Cell$a, rowTw, 0)
          .from(tableCol3Cell$a, rowTw, 0)
          .from(tableCol4Cell$a, rowTw, 0)
        ScrollTrigger.create({
          trigger: tableTable$,
          start: 'top 60%',
          // end: '+=100%',
          // scrub: true,
          //
          toggleActions: 'play none none reverse',
          animation: tableTl,
        })

        // Footer

        const cta$ = sel('.epic-cta-sec')
        const ctaH$ = cta$.querySelector('h2')
        const ctaHsT$ = SplitText.create(ctaH$, { type: 'words, chars' })
        const ctaP$ = cta$.querySelector('.epic-cta__info>div:not(.button-group)')
        const ctaBtn$ = cta$.querySelector('.btn')
        const ctaBgSvg$ = cta$.querySelector('.epic-cta__bg-w.is--svg')
        const ctaBgWebp$ = cta$.querySelector('.epic-cta__bg-w-w.is--webp')
        const footer$ = sel('.footer')
        console.log(ctaBgSvg$, ctaBgWebp$)
        if (isSafariMac) {
          ctaBgSvg$.style.display = 'none'
          ctaBgWebp$.style.display = 'block'
        }

        const ctaTl = gsap
          .timeline({ defaults: { ease: 'power3.out', duration: 1 } })
          //
          .from(
            ctaHsT$.chars,
            {
              autoAlpha: 0,
              // filter: 'blur(50px)',
              ...chromeBlur,
              stagger: 0.03,
              ease: 'none',
            },
            0
          )
          .from(ctaP$, { autoAlpha: 0, y: -20 }, '<50%')
          .from(ctaBtn$, { autoAlpha: 0, y: -20 }, '<10%')
          .from(footer$, { y: 20, autoAlpha: 0, duration: 3 }, '<10%')

        ScrollTrigger.create({
          trigger: cta$,
          start: 'top 80%',
          // end: '+=100%',
          // scrub: true,
          animation: ctaTl,
          toggleActions: 'play none none reverse',
        })
      })
    })
    stResizeObserver()
    // console.log('Epic.js executed')
  })
}
